import { createSelector } from '@reduxjs/toolkit'

export const makeSelectorUserdata = () => createSelector(
  (state) => state.login,
  (slice) => {
    return slice.userData
  }
)
